import { hash } from '@ember/helper';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsMlpDownloadLinkFormComponent extends Component {
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <form.fieldset @titleKey='general' as |fieldset|>
        <fieldset.field @property='asset' @type='belongs-to' />
        <fieldset.field @property='emailSenderName' />
        <fieldset.field @property='emailLogoImage' />
        <fieldset.field @property='emailTeaserImage' />
        <fieldset.field @property='dotDigitalCampaignId' />
        <fieldset.field @property='campaign' />
        <fieldset.field
          @property='newsletterTarget'
          @type='belongs-to'
          @disabled={{@loadLegalContext.isPending}}
          @filters={{hash legalContext=@loadLegalContext.value}}
        />
      </form.fieldset>
    </Form>
  </template>
}
